/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Notification_Agent_Run_FailedInputs */



/**
* | output |
* | --- |
* | "A run of {name} failed" |
*
* @param {Notification_Agent_Run_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notification_agent_run_failed = /** @type {((inputs: Notification_Agent_Run_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notification_Agent_Run_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ein Lauf von ${i?.name} ist fehlgeschlagen.`)
	return /** @type {LocalizedString} */ (`A run of ${i?.name} failed`)
});